import React, { useEffect, useMemo } from "react";
import moment from "moment-timezone";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useUsersContext } from "../../context/usersContext";
import { useUserInfo } from "../../context/user";
import PromptModal from "./components/PromptModal";

const getUtcOffset = () => {
  const offsetInMinutes = -new Date().getTimezoneOffset();
  const sign = offsetInMinutes >= 0 ? "+" : "-";
  const absoluteMinutes = Math.abs(offsetInMinutes);
  const hours = String(Math.floor(absoluteMinutes / 60)).padStart(2, "0");
  const minutes = String(absoluteMinutes % 60).padStart(2, "0");
  return `${sign}${hours}:${minutes}`;
};

const PromptPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { tasksData, fetchTasksData, selectedAssistant } = useUsersContext();
  const [, , , , userActiveLocation] = useUserInfo();

  const timeZone = moment.tz.guess() || "UTC";
  const isEdit = Boolean(id) && id !== "new";

  const editadata = useMemo(() => {
    if (!isEdit) return null;
    const list = tasksData?.prompt || [];
    return list.find((task) => (task?._id || task?.id) === id) || null;
  }, [isEdit, id, tasksData]);

  useEffect(() => {
    if (!tasksData?.prompt) {
      fetchTasksData?.();
    }
  }, [tasksData, fetchTasksData]);

  const fallbackAssistant = selectedAssistant || {
    assistant_name: "Brand AI",
    modal_name: "openai/gpt-4o",
    assistant_id: userActiveLocation?.assistant_id,
    status: true,
  };

  const handleClose = () => {
    navigate("/app/chat/tasks");
  };

  const autoloadfirsttext = location.state?.autoloadfirsttext || "";

  return (
    <PromptModal
      renderAs="page"
      onClose={handleClose}
      justCloseIt={handleClose}
      getUpdatePromptsData={fetchTasksData}
      editadata={editadata}
      autoloadfirsttext={autoloadfirsttext}
      time_zone={timeZone}
      timeWithZone={moment
        .tz(editadata?.scheduleTime, timeZone)
        .format("HH:mm")}
      utcOffset={getUtcOffset()}
      assistantData={
        fallbackAssistant?.assistant_id ? [fallbackAssistant] : []
      }
      asistantSelected={fallbackAssistant}
    />
  );
};

export default PromptPage;
